import React from "react";
import {
  Box,
  CircularProgress,
  makeStyles,
  Typography,
} from "@material-ui/core";
import TabHeader from "../TabHeader";

const useStyles = makeStyles((theme) => ({
  heading: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    fontWeight: 600,
    textTransform: "capitalize",
  },
  entriesCount: {
    fontSize: "1rem",
    minWidth: "2rem",
    padding: "0.5rem",
    width: "auto",
    height: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "1rem",
    background: "#E2EBFF",
    marginRight: "0.5rem",
  },
}));

const EntriesCount = ({ children, isLoading, ...rest }) =>
  isLoading || children || typeof children === "number" ? (
    <Box {...rest}>
      {isLoading ? <CircularProgress size="1rem" /> : children ?? "NA"}
    </Box>
  ) : (
    ""
  );
const TabPageHeader = ({
  entriesCount,
  isLoading,
  title,
  actions,
  FilterComponent,
  PinComponent,
  TabTitle,
  status,
  showBackIcon,
  goBackUrl,
  useHistoryToGoBack,
  useStateToGoBack,
  goBackFrom,
  groupId,
  showChip,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.commonspacing}>
      <TabHeader
        TabTitle={TabTitle}
        status={status}
        showBackIcon={showBackIcon}
        goBackUrl={goBackUrl}
        useHistoryToGoBack={useHistoryToGoBack}
        useStateToGoBack={useStateToGoBack}
        goBackFrom={goBackFrom}
        groupId={groupId}
        showChip={showChip}
      />
      <Box
        display="flex"
        marginBottom="2rem"
        marginLeft="1rem"
        marginRight="1rem"
        marginTop="2rem"
        width="auto
        "
      >
        <Typography variant="h3" className={classes.heading}>
          <EntriesCount className={classes.entriesCount} isLoading={isLoading}>
            {entriesCount}
          </EntriesCount>
          {title}
          {FilterComponent || ""}
          {PinComponent}
        </Typography>
        {actions}
      </Box>
    </div>
  );
};

export default TabPageHeader;
